// routes
import Router from "./routes";
import { useEffect, useState } from "react";
// theme
import ThemeProvider from "./theme";
// components
import ScrollToTop from "./components/scroll-to-top";
import { StyledChart } from "./components/chart";
import LoginPage from "./pages/LoginPage";
import { useSearchParams } from "react-router-dom";
import { CircularProgress, Box } from "@mui/material";
import axios from "axios";
// ----------------------------------------------------------------------

export default function App() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [showLogin, setShowLogin] = useState(false);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      axios.defaults.headers.common["authorization"] = token;
    }
    console.log("local storage token", token);
    if (!token && !searchParams.has("token")) {
      setLoading(false);
      setShowLogin(true);
    } else if (searchParams.has("token")) {
      console.log("Make request", searchParams.get("token"));
      axios
        .post(`${process.env.REACT_APP_API_BASE_URL}/admin/login-with-token`, {
          token: searchParams.get("token"),
        })
        .then(function (response) {
          axios.defaults.headers.common["authorization"] = response.data.token;
          localStorage.setItem("token", response.data.token);
          localStorage.setItem("name", response.data.name);
          localStorage.setItem("role", response.data.role);
          setLoading(false);
          console.log(response.data);
        });
    } else {
      setLoading(false);
    }
  }, []);

  if (showLogin) {
    return (
      <ThemeProvider>
        <LoginPage />
      </ThemeProvider>
    );
  }
  return loading ? (
    <Box
      sx={{ display: "flex", justifyContent: "center" }}
      style={{ padding: 220 }}
    >
      <CircularProgress />
    </Box>
  ) : (
    <ThemeProvider>
      <ScrollToTop />
      <StyledChart />
      <Router />
    </ThemeProvider>
  );
}
